import { GlButton, GlModal, GlModalDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { uniqueId } from 'lodash-es';
import { s__, __ } from '~/locale';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'ArchiveDesignButton',
    components: {
        GlButton,
        GlModal
    },
    directives: {
        GlModalDirective
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        hasSelectedDesigns: {
            type: Boolean,
            required: false,
            default: true
        },
        loading: {
            type: Boolean,
            required: false,
            default: false
        },
        buttonIcon: {
            type: String,
            required: false,
            default: undefined
        },
        buttonCategory: {
            type: String,
            required: false,
            default: 'primary'
        },
        buttonClass: {
            type: String,
            required: false,
            default: ''
        },
        buttonSize: {
            type: String,
            required: false,
            default: 'small'
        }
    },
    emits: [
        'archive-selected-designs'
    ],
    data () {
        return {
            modalId: uniqueId('design-archive-confirmation-')
        };
    },
    modal: {
        title: s__('DesignManagement|Are you sure you want to archive the selected designs?'),
        text: s__('DesignManagement|Archived designs will still be available in previous versions of the design collection.'),
        actionPrimary: {
            text: s__('DesignManagement|Archive designs'),
            attributes: {
                variant: 'confirm',
                'data-testid': 'confirm-archiving-button'
            }
        },
        actionCancel: {
            text: __('Cancel')
        }
    }
};
